










































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class InputText extends Vue {
    @Prop({ type: String }) readonly vid!: string
    @Prop({ type: Boolean, default: false }) readonly notNullable!: boolean
    @Prop({ type: Boolean, default: false }) readonly trim!: boolean
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
    @Prop({ type: Boolean, default: false }) readonly inline!: boolean
    @Prop({ type: Boolean, default: false }) readonly readonly!: boolean
    @Prop({ type: String, default: 'text' }) readonly type!: string
    @Prop({ type: String, default: 'text' }) readonly inputmode!: string
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop({ default: null }) readonly maxRecommendedCharacters!: number
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    @Prop() readonly textLeft!: string
    @Prop() readonly textRight!: string
    @Prop() readonly clickLeft!: () => void
    @Prop() readonly clickRight!: () => void
    @Prop() readonly step!: string
    @Prop() readonly wrapperClass!: string|object[]|object
    @Prop() readonly wrapperStyle!: string|object[]|object
    @Prop() readonly inputClass!: any
    @Prop() readonly inputStyle!: string|object[]|object
    internalValue: string = null
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    transformInput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    transformOutput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (this.notNullable === false && typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    get hasMaxRecommendedCharacters(): boolean {
        return this.maxRecommendedCharacters !== null &&
            this.internalValue !== undefined &&
            this.internalValue !== null
    }

    get maxRecommendedCharactersReached(): boolean {
        return this.hasMaxRecommendedCharacters &&
            this.internalValue.length > this.maxRecommendedCharacters
    }

    get inputListeners() {
        return Object.assign({}, this.$listeners, {
            input: this.onInput,
            focus: this.onFocus,
            blur: this.onBlur,
        })
    }

    get inputAttrs() {
        return Object.assign({}, this.$attrs)
    }

    get outerComponentClass(): object {
        return [
            {
                'input-text--inline': this.inline,
            },
        ]
    }

    componentClass(errors): object {
        return [
            this.inputClass,
            {
                'input-text': true,
                'bd-round-outline': true,
                'input-text--focussed': this.focus,
                'input-text--disabled': this.disabled,
                'input-text--errors': errors.length > 0 && !this.disabled,
                'input-text--character-overflow': this.maxRecommendedCharactersReached,
            },
        ]
    }

    get componentStyle(): object {
        const hasContentRight = this.$slots['content-right'] !== undefined
        const widths = ['1fr']

        if (this.textLeft) {
            widths.unshift('auto')
        }


        if (this.textRight || hasContentRight) {
            widths.push('auto')
        }

        return [
            this.inputStyle,
            {
                'grid-template-columns': widths.join(' '),
            },
        ]
    }
}
